/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { getISRequestAssitanceProductActionAsync } from './DataActionExtension.g';
import { IRequestAssistanceIsProduct } from './DataServiceEntities.g';

/**
 * GetIsRequestAssistanceProduct Input Action
 */
export class GetIsRequestAssistanceProductInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productId: number;
    constructor(productId: number) {
        this.productId = productId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetIsRequestAssistanceProduct-${this.productId}`;
    public getCacheObjectType = () => 'IRequestAssistanceIsProduct';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetIsRequestAssistanceProductData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(args);
    if (productId) {
        return new GetIsRequestAssistanceProductInput(+productId);
    }
    throw new Error('Unable to create GetIsRequestAssistanceProductInput, no productId found on module config or query');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
function action(input: GetIsRequestAssistanceProductInput, ctx: Msdyn365.IActionContext): Promise<IRequestAssistanceIsProduct> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    const response = getISRequestAssitanceProductActionAsync({ callerContext: ctx }, { idColEntry: `${input.productId}` }, input.productId);
    // console.log('ProductId', input.productId);
    // console.log(response);

    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IRequestAssistanceIsProduct>>action,
    // TODO: Give your data action a unique id
    id: 'GetIsRequestAssistanceProduct',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
